import { Form } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { caseNotificationQueryOptions } from "@/features/case-evaluation/api/queries/acitivities-query";
import { caseCollaboratorsQueryOptions, useCaseCollaboratorCanPostMutation } from "@/features/case-record/api/queries/case-collaborator-query";
import { formatDate } from "@/utils/format-date";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";

export default function CaseNotificationHistoryModal({ caseId }: { caseId: string }) {
	const modal = useModal();

	const form = useForm({
		defaultValues: {},
	});

	const notificationQuery = useQuery(
		caseNotificationQueryOptions({
			id: caseId,
		}),
	);

	const notifications = notificationQuery.data?.data;
	console.log(notifications, "notifications");

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<table className="text-sm">
						<thead>
							<tr className="border-b-2 border-border/50">
								<th className="w-[220px] text-left text-foreground-dark p-3">Title</th>
								<th className=" text-left text-foreground-dark p-3">Email</th>
								<th className=" text-left text-foreground-dark p-3">Date Sent</th>
								<th className=" text-left text-foreground-dark p-3">Status</th>
							</tr>
						</thead>
						<tbody>
							{notifications?.map((notification, index) => (
								<tr key={index} className="border-b border-border/50 last:border-b-0">
									<td className="px-3 py-2">{notification.activity ? notification.activity.activity : ""}</td>
									<td className="px-3 py-2">{notification.collaborator_email ? notification.collaborator_email : notification.external_email}</td>
									<td className="px-3 py-2">{notification.created_at ? formatDate(notification.created_at) : ""}</td>
									<td className="px-3 py-2">
										{notification.status === "Sent" ? (
											<div className="flex items-center space-x-2 text-green-600">
												<IconCheck className="w-4 h-4" />
												<span>Sent</span>
											</div>
										) : (
											<div className="flex items-center space-x-2 text-red-600">
												<IconX className="w-4 h-4" />
												<span>Failed</span>
											</div>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</form>
		</Form>
	);
}
